// extracted by mini-css-extract-plugin
export default {"SitemapItem":"SitemapItem__JjB9N","card":"card__mE852","image":"image__h4ZV3","url":"url__1eVTB"};